export const userAgent = navigator.userAgent || navigator.vendor || window.opera;
export const isIOS = /ipad|iphone|ipod/i.test(userAgent);
export const isMobile = /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(userAgent);
export const isDevEnv = process.env.NODE_ENV == "development";
export const isLama = process.env.VUE_APP_APP == "lama";
export const isWyak = process.env.VUE_APP_APP == "wyak";
export const isMisu = process.env.VUE_APP_APP == "misu";
export const isLamaLudo = process.env.VUE_APP_APP == "lama-ludo";
export const isWeParty = process.env.VUE_APP_APP == "weparty";
export const isInChat = process.env.VUE_APP_APP == "inchat";